import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { OrderApprovalAbortHijackModalComponent } from './order-approval-abort-hijack-modal.component';

export const orderApprovalAbortHijackModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.ORDER_APPROVAL_ABORT_HIJACK]: {
      inlineRoot: true,
      component: OrderApprovalAbortHijackModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
